import { render, staticRenderFns } from "./GridInfoPages.vue?vue&type=template&id=21f61164&"
import script from "./GridInfoPages.vue?vue&type=script&lang=js&"
export * from "./GridInfoPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f61164')) {
      api.createRecord('21f61164', component.options)
    } else {
      api.reload('21f61164', component.options)
    }
    module.hot.accept("./GridInfoPages.vue?vue&type=template&id=21f61164&", function () {
      api.rerender('21f61164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoPages/grid/GridInfoPages.vue"
export default component.exports